import { render } from "./VoyageRecord.vue?vue&type=template&id=f36c6f96&scoped=true"
import script from "./VoyageRecord.vue?vue&type=script&lang=js"
export * from "./VoyageRecord.vue?vue&type=script&lang=js"

import "./VoyageRecord.vue?vue&type=style&index=0&id=f36c6f96&scoped=true&lang=css"
import "./VoyageRecord.vue?vue&type=style&index=1&id=f36c6f96&lang=css"
import "./VoyageRecord.vue?vue&type=style&index=2&id=f36c6f96&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=3&id=f36c6f96&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f36c6f96"]])

export default __exports__